
const directions = [ 'N', 'NO', 'NO', 'O', 'O', 'ZO', 'ZO', 'Z', 'Z', 'ZW', 'ZW', 'W', 'W', 'NW', 'NW', 'N' ];

export function directionLabel(degrees) {
  var n = directions.length;
  var a  = 360 / n;
  var q = Math.floor((degrees / a) % n);
  return directions[q];
}



// WEBPACK FOOTER //
// ./src/utils/utils.js